import * as React from 'react';
import { BadgeSVGProps } from '../../BadgeImage/BadgeImage.types';

export const Bar = ({
	finish,
	shineAsset,
}: BadgeSVGProps) => (
	<svg 
		version="1.1" 
		id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlnsXlink="http://www.w3.org/1999/xlink" 
		x="0px" 
		y="0px"
		viewBox="0 0 400 91" 
		enableBackground="new 0 0 400 91" 
		xmlSpace="preserve">
		<g>
			<g>
				<linearGradient 
					id="SVGID_3_" 
					className="background-colour" 
					gradientUnits="userSpaceOnUse" x1="176.5425" 
					y1="-6.6683" 
					x2="177.8067" 
					y2="-6.6683" 
					gradientTransform="matrix(2.828485e-09 -63 -63 -2.828485e-09 -220.1146 11207.5215)"
				>
					<stop  offset="0" style={{stopColor: "#072653"}}/>
					<stop  offset="0.5347" style={{stopColor: "#072551"}} />
					<stop  offset="0.7297" style={{stopColor: "#07224A"}}/>
					<stop  offset="0.8686" style={{stopColor: "#061D3"}}/>
					<stop  offset="0.9808" style={{stopColor: "#05162E"}}/>
					<stop  offset="1" style={{stopColor: "#05142A"}} />
				</linearGradient>
				
				<path 
					className="background-colour" 
					fill="url(#SVGID_3_)"
					d="M394.2,45.5c0,21.9,0,27.6,0.1,39.8H5.7c0-25.1,0-17.9,0-39.8s0-21.9,0-39.8h388.5
					C394.4,24.6,394.2,23.6,394.2,45.5z"
				/>

				<linearGradient 
					id="SVGID_4_" 
					gradientUnits="userSpaceOnUse" 
					x1="200" 
					y1="91.033" 
					x2="200" 
					y2="1.018969e-02"
				>
					<stop  offset="0" style={{ stopColor: finish.dark }} />
					<stop  offset="3.285236e-02" style={{ stopColor: finish.dark }} />
					<stop  offset="7.363299e-02" style={{ stopColor: finish.dark }} />
					<stop  offset="0.1218" style={{ stopColor: finish.dark }} />
					<stop  offset="0.1814" style={{ stopColor: finish.light }} />
					<stop  offset="0.2649" style={{ stopColor: finish.light }} />
					<stop  offset="0.4969" style={{ stopColor: finish.light }} />
					<stop  offset="0.7315" style={{ stopColor: finish.light }} />
					<stop  offset="0.816" style={{ stopColor: finish.light }} />
					<stop  offset="0.8762" style={{ stopColor: finish.dark }} />
					<stop  offset="0.9249" style={{ stopColor: finish.dark }} />
					<stop  offset="0.9661" style={{ stopColor: finish.dark }} />
					<stop  offset="0.9993" style={{ stopColor: finish.dark }} />
				</linearGradient>

				<path fill="url(#SVGID_4_)" d="M394.2,45.5h-5.7c0,0.1,0,0.2,0,0.3c0,21.6,0,27.4,0.1,39.5l5.7,0v-5.7H5.7v5.7h5.7
					c0-25.1,0-17.9,0-39.8s0-21.9,0-39.8H5.7v5.7h388.5V5.7l-5.7,0c0,6.3,0.1,10.4,0.1,13.8c0,6.9-0.1,11.4-0.1,26H394.2h5.7
					c0-14.6,0.1-19,0.1-26c0-3.5,0-7.6-0.1-13.9l0-5.6H0v5.7c0,17.9,0,17.9,0,39.8c0,21.9,0,14.7,0,39.8V91h400l0-5.7
					c-0.1-12.1-0.1-17.8-0.1-39.5c0-0.1,0-0.2,0-0.3H394.2z"/>
			</g>
			
			<image 
				overflow="visible" 
				width="488" 
				height="122" 
				xlinkHref={shineAsset}
				transform="matrix(1.0092 0 0 1.0092 -46.5649 -16.1159)"
			/>
		</g>
	</svg>
);
